import { TEMPLATE_TYPE } from '../../../constants/messageTemplateKeys';

export function formatTemplateTypeLabel(value) {
  const normalized = String(value ?? '').toLowerCase();
  if (!normalized) return '';
  if (normalized === TEMPLATE_TYPE.MARKETING) return 'Marketing';
  if (normalized === TEMPLATE_TYPE.TRIGGER) return 'Trigger';
  return String(value);
}
